<button id="submitpopup" style="display:none;" data-bs-toggle="modal" data-bs-target="#submit_popup"></button>
<div class="modal" id="submit_popup" role="dialog" aria-label="modal">
  <!-- Modal content -->
  <div class="modal-dialog">
    <div class="modal-content modal-content-40">
      <button class="close delete-close" data-bs-dismiss="modal"><img src="assets/images/close_circle.svg"
          alt="Close"></button>
      <div class="modal-main-content">
        <h2 class="modal-heading center mt-0" tabindex="0">Approve Action Plans</h2>
        <p class="modal-heading center" tabindex="0">You still have input forms that need to be approved.
        <p>
          <a class="button-container button-container-center" href="javascript:void(0)" data-bs-dismiss="modal"
            (click)="decisionStatusPage()">[Return to Action Plan Status Page]</a>
        <div class="button-container button-container-center">
          <button type="button" class="modal-button yes-button" data-bs-dismiss="modal">OK</button>
        </div>
      </div>
    </div>
  </div>
</div>